import { atom } from "recoil"
export const acceptMatchingTermFlagState = atom<boolean>({
  key: "atoms/matching/acceptMatchingTermFlagState",
  default: false,
})
